import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { RecaptchaModule, RecaptchaFormsModule } from 'ng-recaptcha-2';
import { SharedModule } from '../shared/shared.module';
import { LoginV2Component } from './loginV2/login.component';
import { ForgotPasswordComponent } from './forgot-password/forgot-password.component';
import { SignupV2Component } from './signupV2/signup.component';
import { ConfirmAccountComponent } from './confirm-account/confirm-account.component';

@NgModule({
	imports: [
		RouterModule,
		SharedModule,
		RecaptchaModule,
		RecaptchaFormsModule,
	],
	declarations: [
		LoginV2Component,
		ForgotPasswordComponent,
		SignupV2Component,
		ConfirmAccountComponent,
	],
})
export class LoginModule {
}
